import React from "react";
import { useObserver } from "mobx-react-lite";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Collapse,
  TextField,
  Radio,
  Switch,
} from "@material-ui/core";
import { AsyncButton, Select } from "components";
import { useStore } from "./Store";
import { useFormStore } from "./FormStore";

const useStyles = makeStyles((theme) => ({
  collapse: {
    paddingLeft: theme.spacing(2),
  },
}));

const findName = (data: { id: number; name: string }[], id: number) => {
  const d = data.find((d) => d.id === id);
  return d ? d.name : undefined;
};

export default () => {
  const styles = useStyles();
  const store = useStore();
  const formStore = useFormStore();

  const handleLoginId = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.loginId = e.target.value;
    },
    [formStore]
  );

  const handlePassword = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.password = e.target.value;
    },
    [formStore]
  );

  const handleIsActive = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.isActive = e.target.checked;
    },
    [formStore]
  );

  const handleType = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.agencyId = e.target.value === "agency" ? 0 : undefined;
      formStore.value.developerId =
        e.target.value === "developer" ? 0 : undefined;
    },
    [formStore]
  );

  const handleAgencyId = React.useCallback(
    (value) => {
      formStore.value.agencyId = value ? value.value : 0;
    },
    [formStore]
  );

  const handleDeveloperId = React.useCallback(
    (value) => {
      formStore.value.developerId = value ? value.value : 0;
    },
    [formStore]
  );

  const isAdmin =
    formStore.value.agencyId === undefined &&
    formStore.value.developerId === undefined;
  const isAgency =
    formStore.value.agencyId !== undefined &&
    formStore.value.developerId === undefined;
  const isDeveloper =
    formStore.value.agencyId === undefined &&
    formStore.value.developerId !== undefined;

  const save = React.useCallback(async () => {
    if (await formStore.save()) {
      store.fetchUsers();
    }
  }, [store, formStore]);

  return useObserver(() => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="メールアドレス"
          value={formStore.value.loginId || ""}
          error={!!formStore.errors.columns.loginId}
          helperText={formStore.errors.columns.loginId}
          onChange={handleLoginId}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="パスワード"
          type="password"
          value={formStore.value.password || ""}
          error={!!formStore.errors.columns.password}
          helperText={formStore.errors.columns.password}
          onChange={handlePassword}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl>
          <FormLabel>ステータス</FormLabel>
          <Switch
            color="primary"
            name="agencyId"
            checked={formStore.value.isActive}
            onChange={handleIsActive}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth>
          <FormLabel>アカウントの権限</FormLabel>
          <FormGroup>
            <FormControlLabel
              label="Admin"
              control={
                <Radio
                  checked={isAdmin}
                  color="secondary"
                  name="type"
                  value="admin"
                  onChange={handleType}
                />
              }
            />

            <FormControlLabel
              label="代理店"
              control={
                <Radio
                  checked={isAgency}
                  color="secondary"
                  name="type"
                  value="agency"
                  onChange={handleType}
                />
              }
            />

            <Collapse className={styles.collapse} in={isAgency}>
              <Select
                placeholder="代理店を選択してください"
                isClearable
                error={!!formStore.errors.columns.agencyId}
                helperText={formStore.errors.columns.agencyId}
                onChange={handleAgencyId}
                value={
                  formStore.value.agencyId
                    ? {
                        label: findName(
                          formStore.agencies,
                          formStore.value.agencyId
                        ),
                        value: formStore.value.agencyId,
                      }
                    : null
                }
                options={formStore.agencies.map((agency) => ({
                  label: agency.name,
                  value: agency.id,
                }))}
              />
            </Collapse>

            <FormControlLabel
              label="開発者"
              control={
                <Radio
                  checked={isDeveloper}
                  color="secondary"
                  name="type"
                  value="developer"
                  onChange={handleType}
                />
              }
            />

            <Collapse className={styles.collapse} in={isDeveloper}>
              <Select
                placeholder="開発者を選択してください"
                isClearable
                error={!!formStore.errors.columns.developerId}
                helperText={formStore.errors.columns.developerId}
                onChange={handleDeveloperId}
                value={
                  formStore.value.developerId
                    ? {
                        label: findName(
                          formStore.developers,
                          formStore.value.developerId
                        ),
                        value: formStore.value.developerId,
                      }
                    : null
                }
                options={formStore.developers.map((developer) => ({
                  label: developer.name,
                  value: developer.id,
                }))}
              />
            </Collapse>
          </FormGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <AsyncButton onAwait={save}>保存</AsyncButton>
      </Grid>
    </Grid>
  ));
};
